import axios from '@/utils/request'

export default {
  states: ['newly', 'agreed', 'rejected', 'outed'],
  // 2020-09-13
  search(params) {
    return axios.get('/damages', params)
  },
  // // 2020-09-08 
  // create(params) {
  //   return axios.post('/damages', params)
  // },
  // 2020-11-17
  inventoryDamage(params) {
    return axios.post('/damages/inventory-damage', params)
  },
  // 2020-09-13
  update(id, params) {
    return axios.put('/damages/' + id, params)
  },
  // 2020-09-13
  delete(id) {
    return axios.delete('/damages/' + id)
  },
  //  2020-11-17
  agree(id) {
    return axios.put('/damages/' + id + '/agree')
  },
  //  2020-09-13
  reject(id, params) {
    return axios.put('/damages/' + id + '/reject', params)
  },
  // 2020-11-28
  pendingAgreeCount(params) {
    return axios.get('/damages/pending-agree-count', params)
  }
}
